import { takeLatest, call, put, select } from 'redux-saga/effects';
import SECTION_TYPES from './types';
import sectionActions from './actions';
import notificationActions from '../Notifications/actions';
import { sagaWrapper } from 'src/helpers';
import { type IResponse } from 'src/models';
import { type RootState } from 'src/store';
import Service from 'src/service';

const Section = new Service('sections');

function* getAll({ payload }: any) {
	const response: IResponse = yield call(
		Section.getPath,
		`?courseId=${payload.courseId}`,
	);
	yield put(sectionActions.setAll(response.data));
}

function* getOne({ payload }: any) {
	const response: IResponse = yield call(Section.getOne, payload.id);
	yield put(sectionActions.setOne(response.data));
}

function* create({ payload }: any) {
	const section = payload.section;
	yield call(Section.create, section);
	yield put(sectionActions.getAll(section.courseId));
}

function* update({ payload }: any) {
	const section = payload.section;
	yield call(Section.update, section);
	yield put(notificationActions.add('success', 'Sección actualizada'));
	yield put(sectionActions.getOne(section.id));
}

function* updateShowRandom({ payload }: any) {
	yield call(
		Section.updatePath,
		`${payload.id}/showRandom?value=${payload.value}`,
		{},
	);
	yield put(notificationActions.add('success', 'Sección actualizada'));
}

function* updateQuestionsExam({ payload }: any) {
	yield call(
		Section.updatePath,
		`${payload.id}/questionsExam?value=${payload.value}`,
		{},
	);
	yield put(notificationActions.add('success', 'Sección actualizada'));
}

function* getByUser({ payload }: any) {
	const userId: string = yield select(
		(state: RootState) => state.auth.data.id,
	);
	const response: IResponse = yield call(
		Section.getPath,
		`user?courseId=${payload.courseId}&userId=${userId}`,
	);
	yield put(sectionActions.setAll(response.data));
}

function* updateOrder({ payload }: any) {
	yield call(Section.updatePath, `order`, payload.sections);
	yield put(notificationActions.add('success', 'Orden actualizado'));
	yield put(sectionActions.getAll(payload.courseId));
}

function* track({ payload }: any) {
	const { sectionId, userId, type } = payload;
	yield call(
		Section.updatePath,
		`track?sectionId=${sectionId}&userId=${userId}&type=${type}`,
		{},
	);
}

export default function* index() {
	yield takeLatest(
		SECTION_TYPES.GET_ALL,
		sagaWrapper(getAll, sectionActions.setAll([])),
	);
	yield takeLatest(
		SECTION_TYPES.GET_ONE,
		sagaWrapper(getOne, sectionActions.setOne({})),
	);
	yield takeLatest(SECTION_TYPES.CREATE, sagaWrapper(create));
	yield takeLatest(SECTION_TYPES.UPDATE, sagaWrapper(update));
	yield takeLatest(
		SECTION_TYPES.UPDATE_SHOW_RANDOM,
		sagaWrapper(updateShowRandom),
	);
	yield takeLatest(
		SECTION_TYPES.UPDATE_QUESTIONS_EXAM,
		sagaWrapper(updateQuestionsExam),
	);
	yield takeLatest(
		SECTION_TYPES.GET_BY_USER,
		sagaWrapper(getByUser, sectionActions.setAll([])),
	);
	yield takeLatest(SECTION_TYPES.UPDATE_ORDER, sagaWrapper(updateOrder));
	yield takeLatest(SECTION_TYPES.TRACK, sagaWrapper(track));
}
